import { DataItemType, FormControlType } from "../../../../form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
const info = {
    title: "表单标题",
    type: "formTitle",
    icon: "",
    dataItemType: DataItemType.ShortText,
    formControllerType: FormControlType.Title,
    group: "",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
    },
};
